import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tasama/api-client-query';
import { I18nProvider, i18n, initI18n } from '@tasama/i18n';
import App from './App';
import { queryClient } from './config/api-config';
import { env } from '@tasama/config/portal';
import './index.css';

initI18n(env.I18N_COOKIE_DOMAIN || undefined);

const container = document.getElementById('root');
if (!container) {
  throw new Error(i18n.t('app.errors.rootElementNotFound'));
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <I18nProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </I18nProvider>
  </React.StrictMode>
);
